import { Component } from '@angular/core';
import { AccessService } from './services/AccessService';
import { Router } from '@angular/router';
import { ThemeService } from './services/ThemeService';

@Component({
  selector: 'app-root',
  standalone: false,
  template: '<router-outlet />',
})
export class ApplicationComponent {
  public title = 'Client application';
  public constructor(
    private accessService: AccessService,
    private themeService: ThemeService,
    private router: Router,
  ) {
    void this.initializeApplicaiton();
  }

  private async initializeApplicaiton(): Promise<void> {
    this.accessService.initialize();
    this.themeService.initialize();
    if (!this.accessService.isAuthorized()) {
      if (!this.userIsOnRegistrationOrSignInPage()) {
        await this.router.navigate([
          'sign-in',
        ]);
      } else {
        // User is on the registration or sign in page, just stay here
      }
    } else if (this.userIsOnRegistrationOrSignInPage()) {
      await this.router.navigate([
        'dashboard',
      ]);
    }
  }

  private userIsOnRegistrationOrSignInPage(): boolean {
    return [
      '/registration',
      '/sign-in',
    ].includes(window.location.pathname);
  }
}
